import { SDKStage, SDKStageType } from "../models/sdk";
/**
 * Keeps track of initialization / shutdown processing stage of SDK.
 * */

export function isInterrupted(process: string, state: SDKStageType, stage:SDKStage): boolean {
    const isInterrupted = state !== stage.state;
    if (isInterrupted) console.warn(`Warning: SDK ${process} was interruped by another process:`, stage.state);
    return isInterrupted;
}

/**
 * Determines if SDK is processing shutdown.
 * */
export function isShutting(stage:SDKStage): boolean {
    return [
        SDKStageType.SHUT_PENDING,
        SDKStageType.SHUT_STARTED,
        SDKStageType.SHUT_ENGAGEMENT,
        SDKStageType.SHUT_ENGAGEMENT_DISSCONNECTED,
        SDKStageType.SHUT_REQUESTED,
        SDKStageType.SHUT_EXECUTED
    ].includes(stage.state);
}

/**
 * Determines if SDK was initialized or processing initialization.
 * */
export function isRunning(stage:SDKStage): boolean {
    return [
        SDKStageType.INIT_STARTED,
        SDKStageType.INIT_ENGAGEMENT,
        SDKStageType.INIT_ENGAGEMENT_CREATED,
        SDKStageType.INIT_REQUESTED,
        SDKStageType.INIT_EXECUTED,
        SDKStageType.INIT_FINISHED
    ].includes(stage.state);
}

/**
 * Determines if SDK shutdown is finished.
 * */
export function isReadyForInit(stage:SDKStage): boolean {
    return [
        SDKStageType.IDLE,
        SDKStageType.INIT_FAILED,
        SDKStageType.SHUT_FINISHED,
        SDKStageType.SHUT_FAILED
    ].includes(stage.state);
}
export function isRetryAllowed(stage:SDKStage): boolean {
    return [
        SDKStageType.INIT_PENDING,
        SDKStageType.INIT_STARTED,
        SDKStageType.INIT_ENGAGEMENT,
        SDKStageType.INIT_ENGAGEMENT_CREATED,
        SDKStageType.INIT_REQUESTED,
        SDKStageType.INIT_EXECUTED,
        SDKStageType.INIT_FINISHED,
        SDKStageType.INIT_FAILED,

    ].includes(stage.state)
}
/**
 * Determines if SDK initialization is finished.
 * */
export function isReadyForShutdown(stage:SDKStage): boolean {
    return [
        SDKStageType.INIT_FINISHED,
        SDKStageType.INIT_FAILED
    ].includes(stage.state);
}

/**
 * Determines if SDK is not initialized.
 * */
export function isNotInitialized(stage:SDKStage): boolean {
    return [
        SDKStageType.IDLE,
        SDKStageType.AUTH_DENIED,
        SDKStageType.AUTH_INTERRUPTED,
        SDKStageType.INIT_FAILED,
        SDKStageType.SHUT_FINISHED
    ].includes(stage.state);
}

/**
 * Determines if SDK authentification started.
 * */
export function isAuthStarted(stage:SDKStage): boolean {
    return [
        SDKStageType.AUTH_STARTED
    ].includes(stage.state);
}